module.exports = __webpack_public_path__ + "images/minus.png";